module.exports = __webpack_public_path__ + "static/media/macaron_pack.af0ccf34.JPG";